import type { OrgSettings, OrgSettingsInput } from '../types';
import { apiClient } from './client';
// #67: frontend OrgSettings now aligned with wire OrgSettings — no alias needed

async function fileToDataUrl(file: File): Promise<string> {
  return new Promise<string>((resolve, reject) => {
    const reader = new FileReader();
    reader.onloadend = () => resolve(reader.result as string);
    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

export const settings = {
  getSettings: async (orgSlug: string): Promise<OrgSettings> => {
    // #67: frontend OrgSettings now matches wire shape — cast removed
    const { data } = await apiClient.get<OrgSettings>(`/api/orgs/${orgSlug}/settings`);
    return data;
  },

  updateSettings: async (orgSlug: string, updates: OrgSettingsInput): Promise<OrgSettings> => {
    const body: Record<string, unknown> = {};

    if (updates.name !== undefined) {
      body.orgName = updates.name;
    }

    if (updates.colorScheme !== undefined || updates.logo) {
      body.settings = {} as Record<string, unknown>;

      if (updates.colorScheme !== undefined) {
        (body.settings as Record<string, unknown>).colorScheme = updates.colorScheme;
      }

      if (updates.logo) {
        (body.settings as Record<string, unknown>).logoUrl = await fileToDataUrl(updates.logo);
      }
    }

    // #67: frontend OrgSettings now matches wire shape — cast removed
    const { data } = await apiClient.patch<OrgSettings>(`/api/orgs/${orgSlug}/settings`, body);
    return data;
  },
};
